<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            SLA Detail
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
    </v-card>

    <v-container class="px-7" fluid>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="auto">
          <v-btn exact to="/sshcp/sla" icon color="bluedarken">
            <v-icon class="icon-bold">mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            SLA Report Detail
          </h1>
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="auto">
          <v-btn color="primary" icon large @click="fetchData()">
            <v-icon color="bluedarken" class="icon-bold icon-large" large>
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-card :loading="loading" class="elevation-card rounded-12 mb-5">
        <v-card-title>
          <div class="mr-2">
            <v-img
              src="@/assets/images/icon-file-text.png"
              width="20"
              height="20"
            />
          </div>
          <span class="fs-14 font-weight-bold primary2--text">
            {{ detail.unique_code }}
          </span>
          <v-spacer />
          <!-- <select-column-filter v-model="columnActive" :headers="headers" /> -->
          <!-- <v-btn
            depressed
            dark
            color="menuActive"
            class="btn-medium"
            @click="download"
          >
            Download
          </v-btn> -->
        </v-card-title>

        <v-card-text>
          <v-simple-table
            fixed-header
            class="table-taxonomy nav-table sshcf-table"
          >
            <template v-slot:default>
              <VuePerfectScrollbar
                class="drawer-menu--scroll"
                :settings="scrollSettings"
              >
                <thead>
                  <tr>
                    <template v-for="header in headers">
                      <th
                        :key="header.text"
                        class="white--text"
                        :class="{
                          [`text-${header.align}`]: true,
                          [header.customClass]: !!header.customClass
                        }"
                      >
                        <span>{{ header.text }}</span>
                        <!-- <filter-column
                          v-if="header.value !== 'action'"
                          :indexItem="index"
                          :field="header.value"
                          :listFilter="getFiltered(header.value, index)"
                          @sortAsc="getNestedSort"
                          @searchColumn="searchCln"
                          @filterItem="searchCln"
                        /> -->
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <template v-for="header in headers">
                      <td
                        :key="header.name"
                        :class="{
                          [header.tdClass]: true,
                          [`text-${header.align}`]: true,
                          [header.tdClass]: !!header.tdClass
                        }"
                      >
                        <router-link
                          v-if="header.linkable"
                          :to="`/sshcp/request/${item.id}`"
                          class="bluedarken--text text-link"
                        >
                          {{ item.unique_code }}
                        </router-link>
                        <template v-else-if="header.value === 'name'">
                          <span
                            v-if="item.name.length === 1"
                            class="text-capitalize"
                          >
                            {{ item.name[0].name }}
                          </span>
                          <v-menu open-on-hover top offset-y v-else>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">{{ item.name[0].name }}, ...</div>
                            </template>
                            <v-card
                              flat
                              outlined
                              :elevation="0"
                              style="boder-radius: 25px !important"
                            >
                              <v-card-title
                                class="blue-grey lighten-5 fs-12 px-2 py-0 grey--text text--darken-1"
                              >
                                <span class="font-weight-bold">Name</span>
                              </v-card-title>
                              <v-card-text
                                class="fs-12 grey--text text--darken-1 pa-2"
                              >
                                <v-flex
                                  xs12
                                  v-for="(name, idx) in item.name"
                                  :key="'name' + idx"
                                >
                                  <v-icon color="primary" class="mr-1 fs-12">
                                    {{
                                      name.isApproved
                                        ? 'radio_button_checked'
                                        : 'radio_button_unchecked'
                                    }}
                                  </v-icon>
                                  <span class="text-capitalize">
                                    {{ name.name }}
                                  </span>
                                </v-flex>
                              </v-card-text>
                            </v-card>
                          </v-menu>
                        </template>
                        <template v-else-if="header.value === 'email'">
                          <span v-if="item.email.length === 1">
                            {{ item.email[0] }}
                          </span>
                          <v-menu open-on-hover top offset-y v-else>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">{{ item.email[0] }}, ...</div>
                            </template>
                            <v-card
                              flat
                              outlined
                              :elevation="0"
                              style="boder-radius: 25px !important"
                            >
                              <v-card-title
                                class="blue-grey lighten-5 fs-12 px-2 py-0 grey--text text--darken-1"
                              >
                                <span class="font-weight-bold">Email</span>
                              </v-card-title>
                              <v-card-text
                                class="fs-12 grey--text text--darken-1 pa-2"
                              >
                                <v-flex
                                  xs12
                                  v-for="(email, idx) in item.email"
                                  :key="'email' + idx"
                                >
                                  <span>- {{ email }}</span>
                                </v-flex>
                              </v-card-text>
                            </v-card>
                          </v-menu>
                        </template>
                        <span v-else>
                          {{ header | tableRowValue(item) }}
                        </span>
                      </td>
                    </template>
                  </tr>
                  <tr v-if="!items.length">
                    <td :colspan="headers.length" class="text-center">
                      {{ loading ? 'Loading...' : 'No data available' }}
                    </td>
                  </tr>
                </tbody>
              </VuePerfectScrollbar>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: ['id'],
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 340
    },
    columnActive: [],
    breadcrumbs: [
      {
        text: 'SSHCP',
        to: '/sshcp/'
      },
      {
        text: 'Request',
        to: '/sshcp/request/'
      }
    ],
    totalItems: 0,
    options: {
      itemsPerPage: 10,
      page: 1
    },
    loadingDetail: false,
    filter: null,
    loading: false,
    dialog: false,
    headers: [
      {
        text: 'Name',
        align: 'left',
        value: 'name',
        tdClass: 'text-capitalize'
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email'
      },
      {
        text: 'Group',
        align: 'left',
        value: 'group_name'
      },
      {
        text: 'Approval Level',
        align: 'center',
        value: 'level'
      },
      {
        text: 'Action',
        align: 'left',
        value: 'status',
        tdClass: 'text-capitalize'
      },
      {
        text: 'Action Date',
        align: 'left',
        value: 'date'
      },
      {
        text: 'SLA Days',
        align: 'center',
        value: 'sla_days'
      },
      {
        text: 'Notes',
        align: 'left',
        value: 'notes'
      }
    ],
    detail: {},
    items: []
  }),
  computed: {},
  async mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      // get progress tracking
      const data = await this.$store.dispatch(
        'sshcp/getProgressTracking',
        this.id
      );
      // get detail request
      const res = await this.$store.dispatch(
        'sshcp/getFormRequestDetail',
        this.id
      );
      this.detail = res.data.formRequest;
      this.items = data.data.result.map(item => {
        let itemApproved = item.find(val => val.approval_date !== null);
        return {
          group_name: item[0].group_name,
          email: item.map(val => val.email),
          name: item.map(val => {
            return {
              name: val.user_name.toLowerCase(),
              isApproved: !!val.approval_date
            };
          }),
          complete: item[0].status === 'approved',
          date: itemApproved
            ? moment(itemApproved.approval_date)
                .utc()
                .format('DD-MM-YYYY')
            : '',
          status: itemApproved?.status,
          level: item[0].level,
          notes: itemApproved?.notes,
          sla_days: itemApproved?.sla_days
        };
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverable-tr {
  cursor: pointer;

  &:hover {
    background: #dfdfdf;
  }
}

.drawer-menu--scroll {
  max-height: 600px;
  overflow: auto;
}
.v-data-table.table-taxonomy.nav-table.sshcf-table {
  border-right: 0 !important;
  border-bottom: 0 !important;
}
.v-data-table.table-taxonomy.nav-table.sshcf-table thead,
.v-data-table.table-taxonomy.nav-table.sshcf-table td:last-child {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
